import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoanService } from '../../shared-component/service/loan/loan.service';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { ToasterService } from 'angular2-toaster';
import { interval } from 'rxjs';
import { switchMap, takeWhile, tap } from 'rxjs/operators';

@Component({
  selector: 'app-aggregator',
  templateUrl: './aggregator.component.html',
  styleUrls: ['./aggregator.component.scss'], animations: [
    trigger('blink', [
      state('visible', style({ opacity: 1 })),
      state('hidden', style({ opacity: 0 })),
      transition('visible <=> hidden', animate('500ms ease-in-out')),
    ]),
  ],
})

export class AggregatorComponent implements OnInit {

  public showeSignButton: boolean = false;
  public underReview: boolean = false;

  public loanDetail: any;
  public tokenId: string;
  public aggregatorUrl: any;
  public crd: any = {};

  constructor(
    private activeRoute: ActivatedRoute,
    private toasterService: ToasterService,
    private router: Router,
    private loanService: LoanService,
  ) { }

  blinkState = 'visible';

  toggleBlink() {
    this.blinkState = this.blinkState === 'visible' ? 'hidden' : 'visible';
  }

  ngOnInit() {
    setInterval(() => {
      this.toggleBlink();
    }, 1000);
    this.getLoanDetails();
    if (this.loanDetail.accountAggregatorCheck > 0) {
      this.aggregatorResponseHandler();
    }
  }

  getLoanDetails() {
    this.activeRoute.data.subscribe((res: any) => {
      this.loanDetail = res.loanDetail;
      this.tokenId = this.loanDetail.token;
    });
    if (this.loanDetail.accountAggregatorCheck == 1 || this.loanDetail.accountAggregatorCheck == 2 && this.loanDetail.applicationStatus == 11) {
      this.underReview = true;
    }
  }

  startAggregator() {
    this.showeSignButton = false;
    this.loanService.sendeAggregatorRequest(this.tokenId).subscribe((res: any) => {
      //console.log("Response", res.data)
      this.aggregatorUrl = res.data.aggregatorLink ? res.data.aggregatorLink : res.data;

      const mediaQuery = window.matchMedia("(max-width: 600px)");
      const isMobile = mediaQuery.matches;
      const popupWidth = isMobile ? window.innerWidth * 0.9 : 500;
      const popupHeight = isMobile ? window.innerHeight * 0.8 : 600;

      const left = (window.innerWidth - popupWidth) / 2;
      const top = (window.innerHeight - popupHeight) / 2;

      const popupOptions = `width=${popupWidth},height=${popupHeight},top=${top},left=${left},scrollbars=yes,resizable=yes`;

      const popupWindow = window.open(this.aggregatorUrl, 'aggregatorPopup', popupOptions);
      if(this.loanDetail.aaType && this.loanDetail.aaType == "FINVU") {
        interval(3000)
          .pipe(
            switchMap(() => {
              return this.loanService.checkFinvuStatus(this.tokenId);
            }),
            tap(res => console.log('Response from API:')),
            takeWhile((res: any) => {
              const condition = !res.data || !res.data.status || this.loanDetail.accountAggregatorCheck != 1;
              return condition;
            }),
            tap((res: any) => {
              if (res.data.status) {
                popupWindow.close();
                setTimeout(() => {
                  this.aggregatorResponseHandler();
                }, 2000);
              }
            })
          )
          .subscribe({
            error: err => console.error('Error in stream:'),
            complete: () => console.log('Polling completed'),
          });

      }
      else{
        window.addEventListener('message', (event) => {
          //console.log('Message from Popup:', event.data);
          if (event.data.status == 'S') {
            popupWindow.close();
            setTimeout(() => {
              this.aggregatorResponseHandler();
            }, 2000);
          }
        });
      }
    });
  }

  async aggregatorResponseHandler() {
    if (this.loanDetail.applicationStatus == 5 && this.loanDetail.accountAggregatorCheck == 2) {
      this.router.navigateByUrl(`/loan/process/${this.tokenId}`, { replaceUrl: true });
    } else if (this.loanDetail.applicationStatus == 5 && this.loanDetail.accountAggregatorCheck == 1) {
      this.router.navigateByUrl(`/loan/process/${this.tokenId}`, { replaceUrl: true });
    } else if (this.loanDetail.accountAggregatorCheck == 1 && this.loanDetail.applicationStatus == 11) {
      this.underReview = true;
    } else {
      this.loanService.updateAggregatorResponse(this.tokenId, this.loanDetail).subscribe((res: any) => {
        window.location.reload();
      })
    }
    error => {
      this.showeSignButton = true;
      this.toasterService.pop('error', '', error.message);
    }
  }
}
